<template>
  <div class="upload-mode-nav">
    <div class="nav">
      <template v-for="item in navs">
        <span
          :key="item.key"
          :data-key="item.key"
          :class="{
            active: item.key === platform,
          }"
          @click="handleSwitchNav"
        >{{ item.name }}</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaticUploadModeNav',
  model: {
    prop: 'platform',
    event: 'change',
  },
  props: {
    platform: {
      type: String,
      default: 'pc',
    },
  },
  data() {
    return {
      navs: [{
        key: 'pc',
        name: '电脑静态壁纸',
      }, {
        key: 'mobile',
        name: '手机静态壁纸',
      }, {
        key: 'all',
        name: '双端静态壁纸',
      }],
    }
  },
  methods: {
    handleSwitchNav($event) {
      const key = $event.currentTarget.dataset.key
      this.$emit('change', key)
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-mode-nav {
  min-height: 20px;
  user-select: none;
  .nav {
    display: flex;
    width: 384px;
    height: 40px;
    margin: 0 auto;
    padding: 0 3px;
    background: #F3F4F6;
    border-radius: 10px;
    span {
      flex: 1;
      height: 34px;
      margin-top: 3px;
      line-height: 34px;
      text-align: center;
      font-size: 12px;
      border-radius: 10px;
      cursor: pointer;
    }
    .active {
      background: #F4C000;
    }
  }
}
</style>
